import { render, staticRenderFns } from "./DeviceData.vue?vue&type=template&id=af279668"
import script from "./DeviceData.vue?vue&type=script&lang=js"
export * from "./DeviceData.vue?vue&type=script&lang=js"
import style0 from "./DeviceData.vue?vue&type=style&index=0&id=af279668&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports